import axios from 'axios';
import { getApiBaseUrl } from '../config/api';

// Konfigurace axios instance
const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Přidání interceptors pro globální error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server vrátil chybu
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      // Request byl odeslán, ale žádná odpověď nebyla obdržena
      console.error('No response received:', error.request);
    } else {
      // Chyba nastala při vytváření requestu
      console.error('Error creating request:', error.message);
    }
    return Promise.reject(error);
  }
);

// Video endpoints
export const uploadVideo = async (formData, options = {}) => {
  return api.post('/upload/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...options, // This allows passing signal for AbortController
  });
};


export const downloadScenes = async (sessionId) => {
  return api.get(`/download_scenes/${sessionId}/`);
};

export const cancelVideoProcessing = async (sessionId) => {
  return api.post(`/cancel/${sessionId}/`);
};

export const submitFeedback = async (message) => {
  return api.post('/feedback/', { message });
};

// Video Merge endpoints
export const uploadMergeVideos = async (formData, options = {}) => {
  return api.post('/merge/upload/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...options, // This allows passing signal for AbortController
  });
};

export const checkMergeStatus = async (sessionId) => {
  return api.get(`/merge/status/${sessionId}/`);
};

export const cancelMergeProcessing = async (sessionId) => {
  return api.post(`/merge/cancel/${sessionId}/`);
};

// Export default instance pro případné globální konfigurace
export default api;
